module.exports = __webpack_public_path__ + "img/firefox-home.168c5fbb.svg";